
import { defineComponent, computed, onMounted, ref, ComponentPublicInstance, nextTick } from "vue";
import SearchTagList from "@/components/search/SearchTagList.vue";
import SearchHistoryTitle from "@/components/search/SearchHistoryTitle.vue";
import SearchHistoryList from "@/components/search/SearchHistoryList.vue";
import CommonDialog from "@/components/common/CommonDialog.vue";
import ApplianceDialog from "@/components/search/ApplianceDialog.vue";
import store from "@/store";
import router from "@/router";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import { useLog } from "@/use/use-log";
import { PAGE_ID } from "@/const/log-const";
import {
  SEARCH_SORT_TYPE,
  SEARCH_RECIPE_TYPE,
  TagGroups,
  TagGroupInfo,
  HistoryItem,
  SearchTag,
  ApplianceData,
  SaveApplianceList,
  SaveApplianceData,
  TagGroup
} from "@/types/search";
import { ApplianceList, SearchApplianceList, BeaconLogInfo, Products, Product } from "@/types/common";
import {
  getViewedItemsString,
  getSearchHistoryKeyword,
  deleteSearchHistoryKeyword
} from "@/utils/search-util";
import NativeClient, { TitleInfo } from "@/client/native-client";


export default defineComponent({
  name: "SearchDetailPage",
  components: {
    SearchTagList,
    // 検索履歴一覧非表示
    // SearchHistoryTitle,
    // SearchHistoryList,
    CommonDialog,
    ApplianceDialog
  },
  setup() {
    const NONE_APPLIANCE_TEXT = "機器連携無し";
    NativeClient.sendDebugLog(
      "setup keyword=" + router.currentRoute.value.query.keyword
    );
    const textInput = ref<HTMLInputElement>();
    const keyword = ref(String(router.currentRoute.value.query.keyword));
    const top = ref(String(router.currentRoute.value.query.top));
    const sortType = ref(String(router.currentRoute.value.query.sort));
    const tagGroupsInfoList = ref(Array<TagGroupInfo>());
    const historyKeywordList = ref(Array<HistoryItem>());
    const isShowApplianceDialog = ref(false);
    const applianceList = ref(Array<ApplianceData>());
    const backupApplianceList = ref(Array<ApplianceData>());
    const selectApplianceText = ref(NONE_APPLIANCE_TEXT);
    try {
      keyword.value = decodeURIComponent(keyword.value);
    } catch (e) {
      NativeClient.sendDebugLog("SearchDetailPage error keyword=" + keyword.value);
    }

    NativeClient.sendDebugLog(
      "SearchDetailPage setup top=" +
        top.value +
        " keyword=" +
        keyword.value +
        " sort=" +
        sortType.value
    );

    const titleInfo = new TitleInfo(false, "検索条件");
    titleInfo.rightIcon = true;
    NativeClient.setTitle(titleInfo);
    scrollTo({ top: 0, left: 0 });
    applianceList.value.length = 0;
    const _sleep = (ms: number) =>
      new Promise(resolve => window.setTimeout(resolve, ms));

    const getSelectsList = (
      searchTags: Array<SearchTag>,
      tagGroup: TagGroup
    ) => {
      const selected = Array<number>();
      if (searchTags != null) {
        searchTags.forEach(e => {
          if (e.alias == tagGroup.alias) {
            tagGroup.tags.forEach(e2 => {
              if (e2.id == e.id) {
                selected.push(e.id);
              }
            });
          }
        });
      }
      return selected;
    };

    NativeClient.sendDebugLog(
      "SearchDetailPage keyword=" +
        keyword.value +
        " top=" +
        top.value +
        " sortType=" +
        sortType.value
    );
    const tagGroupsInfo = computed(() => {
      if (tagGroupsInfo.value != null && tagGroupsInfo.value.length >= 1) {
        return;
      }
      const result: TagGroups = store.getters["search/getTagGroups"];
      const searchTagsText: string | null = store.getters["search/getTags"];
      NativeClient.sendDebugLog(
        "SearchDetailPage tagGroupsInfo result=" + JSON.stringify(result)
      );
      NativeClient.sendDebugLog(
        "SearchDetailPage tagGroupsInfo searchTagsText=" +
          JSON.stringify(searchTagsText)
      );

      let searchTags = Array<SearchTag>();
      if (searchTagsText != "" && searchTagsText != null) {
        searchTags = JSON.parse(searchTagsText);
      }
      if (result != null) {
        const tagGroupsInfo = Array<TagGroupInfo>();
        // if (result.tagGroups.length == 0) {
        //   store.dispatch("search/updateTagGroups", tagGroups);
        //   for (let i = 0; i < tagGroups.tagGroups.length; i++) {
        //     const tagGroupInfo = new TagGroupInfo(tagGroups.tagGroups[i], i);
        //     tagGroupInfo.selected = getSelectsList(searchTags, tagGroups.tagGroups[i]);
        //     tagGroupsInfo.push(tagGroupInfo);
        //   }
        // }
        for (let i = 0; i < result.tagGroups.length; i++) {
          const tagGroupInfo = new TagGroupInfo(result.tagGroups[i], i);
          tagGroupInfo.selected = getSelectsList(
            searchTags,
            result.tagGroups[i]
          );
          NativeClient.sendDebugLog(
            "SearchDetailPage tagGroupsInfo tagGroupInfo=" +
              JSON.stringify(tagGroupInfo)
          );
          tagGroupsInfo.push(tagGroupInfo);
        }
        NativeClient.sendDebugLog(
          "SearchDetailPage tagGroupsInfo tagGroupsInfo=" +
            JSON.stringify(tagGroupsInfo)
        );
        tagGroupsInfoList.value = tagGroupsInfo;
        return tagGroupsInfoList.value;
      } else {
        return null;
      }
    });

    // 検索履歴一覧非表示
    // const setHistoryKeywordList = () => {
    //   const list = getSearchHistoryKeyword();
    //   if (list != null) {
    //     for (let i = 0; i < list.length; i++) {
    //       NativeClient.sendDebugLog(
    //         "SearchDetailPage getSearchHistoryList id=" + list[i].id + " label=" + list[i].label
    //       );
    //     }
    //   } else {
    //     NativeClient.sendDebugLog("SearchDetailPage getSearchHistoryList empty");
    //   }
    //   historyKeywordList.value = list;
    // };
    // setHistoryKeywordList();

    /**
     * レシピリストを取得する
     */
    const getRecipes = async () => {
      applianceList.value.length = 0;
      store.dispatch("common/startLoading");
      store.dispatch("common/updateSearchAppliance", null);
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog(
          "SearchDetailPage getRecipes apiParams=" + JSON.stringify(apiParams)
        );
        if (apiParams.token) {
          Promise.all([
            store.dispatch("search/getTagGroups"),
            store.dispatch("search/getProducts"),
            NativeClient.getSearchAppliance()
          ]).then(result => {
            store.dispatch("common/stopLoading");
          });
        } else {
          Promise.all([store.dispatch("search/getTagGroups")]).then(result => {
            store.dispatch("common/stopLoading");
          });
        }
      });
    };

    /**
     * レシピリストの取得を実行する
     */
    const execute = async () => {
      NativeClient.sendDebugLog(
        "SearchDetailPage execute wait start"
      );
      await _sleep(500);
      NativeClient.sendDebugLog(
        "SearchDetailPage execute wait end"
      );
      getRecipes();
    };

    const getApplianceText = () => {
      let result = NONE_APPLIANCE_TEXT;
      let productCode = "";
      let productCount = 0;

      for (let i = 0; i < applianceList.value.length; i++) {
        const item = applianceList.value[i];
        if (item.check) {
          productCount++;
          if (productCode == "") {
            productCode = item.product.productCode;
          }
        }
      }

      // ToDoチェック状態で判断するように対応
      if (productCount >= 1) {
        result = productCode;
        if (productCount >= 2) {
          result += " 他" + (productCount - 1) + "件";
        }
      }
      return result;
    };

    const loadSearchAppliance = (param: string, products: Array<Product>) => {
      NativeClient.sendDebugLog(
        "SearchDetailPage loadSearchAppliance param=" + JSON.stringify(param)
      );
      if (param == null || param == "") {
        return;
      }
      const appliances: SearchApplianceList = JSON.parse(param);
      if (appliances == null || appliances.applianceList == null) {
        return;
      }
      NativeClient.sendDebugLog(
        "SearchDetailPage loadSearchAppliance=" + products.length
      );
      for (let i = 0; i < appliances.applianceList.length; i++) {
        const item = appliances.applianceList[i];
        NativeClient.sendDebugLog(
          "SearchDetailPage loadSearchAppliance=" + JSON.stringify(item)
        );
        for (let j = 0; j < products.length; j++) {
          const product = products[j];
          let isEqual = false;
          if (product.uniqueId == item.uniqueId) {
            if (item.geminiId != null && item.geminiId != "") {
              if (product.geminiId == item.geminiId) {
                isEqual = true;
              }
            } else if (item.applianceId != null && item.applianceId != "") {
              if (product.applianceId == item.applianceId) {
                isEqual = true;
              }
            }
          }
          if (isEqual) {
            applianceList.value.push(new ApplianceData(j, item.check, product));
            break;
          }
        }
      }
      NativeClient.sendDebugLog(
        "SearchDetailPage loadSearchAppliance applianceList=" +
          JSON.stringify(applianceList)
      );
      return applianceList;
    };

    const getSearchAppliance = computed(() => {
      const result: Products | null = store.getters["search/getProducts"];
      const param = store.getters["common/getSearchAppliance"];
      NativeClient.sendDebugLog(
        "SearchDetailPage computed getSearchAppliance param=" + param
      );
      // チェックボックスの切り替えでも通知される
      if (applianceList.value != null && applianceList.value.length > 0) {
        return applianceList.value;
      }
      applianceList.value.length = 0;
      if (result != null && result.products != null) {
        loadSearchAppliance(param, result.products);
        selectApplianceText.value = getApplianceText();
        return applianceList.value;
      }
      NativeClient.sendDebugLog(
        "SearchDetailPage computed getSearchAppliance empty"
      );
      selectApplianceText.value = NONE_APPLIANCE_TEXT;
      return null;
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.SEARCH_DETAIL, null, new Array<string>());
      NativeClient.sendViewedLog(beaconLogInfo);
      execute();
    });

    /** APIリクエスト時のエラーハンドル */
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();

    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();

    /**
     * レシピカテゴリー取得APIの呼び出しをリトライする
     */
    const retryGetRecipes = () => {
      // ダイアログを閉じる
      closeDialog();
      getRecipes();
    };

    /**
     * 検索キーワードを取得、設定する
     */
    const keywordComputed = computed({
      get: () => keyword.value,
      set: value => (keyword.value = value)
    });

    const setMultipleSelectTagList = (
      selectedTagList: number[],
      id: number
    ) => {
      if (selectedTagList.includes(id)) {
        const index = selectedTagList.findIndex(
          selectedTag => selectedTag === id
        );
        NativeClient.sendDebugLog(
          "SearchDetailPage setTag setMultipleSelectTagList=" +
            JSON.stringify(selectedTagList)
        );
        selectedTagList.splice(index, 1);
      } else {
        selectedTagList.push(id);
      }
      NativeClient.sendDebugLog(
        "SearchDetailPage setTag setMultipleSelectTagList=" +
          JSON.stringify(selectedTagList)
      );
    };

    const setSingleSelectTagList = (selectedTagList: number[], id: number) => {
      selectedTagList.length = 0;
      selectedTagList.push(id);
      NativeClient.sendDebugLog(
        "SearchDetailPage setTag setSingleSelectTagList=" +
          JSON.stringify(selectedTagList)
      );
    };
    /**
     * 検索タグを設定する
     */
    const setTag = (alias: string, id: number) => {
      NativeClient.sendDebugLog(
        "SearchDetailPage setTag alias=" + alias + " tag=" + id
      );
      for (let i = 0; i < tagGroupsInfoList.value.length; i++) {
        const tagGroupInfo = tagGroupsInfoList.value[i];
        if (tagGroupInfo.tagGroup?.alias == alias) {
          if (tagGroupInfo.tagGroup.selectable == 1) {
            setSingleSelectTagList(tagGroupInfo.selected, id);
          } else {
            setMultipleSelectTagList(tagGroupInfo.selected, id);
          }
        }
      }
    };

    /**
     * 検索キーワードを設定する
     */
    const setKeyword = (keyword: string) => {
      NativeClient.sendDebugLog(
        "SearchDetailPage setKeyword keyword=" + keyword
      );
      keywordComputed.value = keyword;
    };

    /**
     * 検索履歴を削除する
     */
    const removeSearchHistory = () => {
      deleteSearchHistoryKeyword();
      historyKeywordList.value.length = 0;
    };

    const onClickClear = () => {
      keyword.value = "";
      for (let i = 0; i < tagGroupsInfoList.value.length; i++) {
        const tagGroupInfo = tagGroupsInfoList.value[i];
        tagGroupInfo.selected.length = 0;
      }
    };

    const isTop = () => {
      return top.value == "1";
    };

    const getSelectTags = () => {
      const searchTags = Array<SearchTag>();
      if (tagGroupsInfo.value != null) {
        for (let i = 0; i < tagGroupsInfo.value.length; i++) {
          const tagGroupInfo = tagGroupsInfo.value[i];
          if (
            tagGroupInfo.selected.length == 0 ||
            tagGroupInfo.tagGroup == null
          ) {
            continue;
          }
          for (let x = 0; x < tagGroupInfo.selected.length; x++) {
            for (let y = 0; y < tagGroupInfo.tagGroup.tags.length; y++) {
              const tags = tagGroupInfo.tagGroup.tags[y];
              if (tagGroupInfo.selected[x] == tags.id) {
                searchTags.push(
                  new SearchTag(tagGroupInfo.tagGroup.alias, tagGroupInfo.tagGroup.description, tags.id, tags.name)
                );
                break;
              }
            }
          }
        }
      }
      return searchTags;
    };

    const sendLogAction = () => {
      const viewedItem = Array<string>();
      // 検索ワード
      const keyword = keywordComputed.value;
      viewedItem.push(keyword);
      // 検索対象
      let appliance = "";
      for (const item of applianceList.value) {
        if (appliance.length != 0) {
          appliance += ",";
        }
        if (item.check) {
          appliance += item.product.productCode;
        }
      }
      appliance = "{" + appliance + "}";
      viewedItem.push(appliance);
      // 選択タグの設定
      if (tagGroupsInfo.value != null) {
        for (const tagGroupInfo of tagGroupsInfo.value) {
          if (tagGroupInfo.tagGroup == null) {
            continue;
          }
          let selectTags = "";
          for (const selectId of tagGroupInfo.selected) {
            for (const tags of tagGroupInfo.tagGroup?.tags) {
              if (selectId == tags.id) {
                if (selectTags.length != 0) {
                  selectTags += ",";
                }
                selectTags += tags.name;
              }
            }
          }
          selectTags = "{" + selectTags + "}";
          selectTags = tagGroupInfo.tagGroup.description + ":" + selectTags;
          viewedItem.push(selectTags);
        }
      }
      const items = getViewedItemsString(viewedItem);
      NativeClient.sendDebugLog("sendLogAction items=" + items);
      const itemList = Array<string>();
      itemList.push(items);
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.SEARCH_DETAIL, "", itemList);
      NativeClient.sendClickedActionLogViewedItemSingleLine(beaconLogInfo);
    };

    const onClickSearch = () => {
      const top = isTop();
      const keyword = keywordComputed.value;
      const sort = sortType.value;
      const searchTags = getSelectTags();
      const searchTagsText = JSON.stringify(searchTags);
      const encodeKeyword = encodeURIComponent(keyword);
      // G-02画面を履歴に残さない為、上書き
      NativeClient.sendDebugLog(
        "SearchDetailPage onClickSearch keyword=" +
          keyword +
          "encodeKeyword" +
          encodeKeyword
      );
      NativeClient.sendDebugLog(
        "SearchDetailPage onClickSearch top=" +
          top +
          " encodeKeyword=" +
          encodeKeyword +
          " sort=" +
          sort +
          " searchTags=" +
          searchTagsText
      );
      sendLogAction();
      if (top) {
        store.dispatch("search/updateKeyword", null);
        store.dispatch("search/updateSortType", null);
        store.dispatch("search/updateTags", null);
        router.replace({
          path: "search",
          query: { sort: sort, tags: searchTagsText, keyword: encodeKeyword }
        });
      } else {
        store.dispatch("search/updateKeyword", keyword);
        store.dispatch("search/updateSortType", sort);
        store.dispatch("search/updateTags", searchTagsText);
        // 検索結果遷移時は画面終了し、検索結果画面を更新
        history.back();
      }
    };

    const saveSearchApplianceList = () => {
      const list = new SaveApplianceList();
      applianceList.value.forEach(e => {
        list.applianceList.push(new SaveApplianceData(e));
      });
      NativeClient.setSearchAppliance(list);
    };

    const showApplianceDialog = async () => {
      if (isShowApplianceDialog.value) {
        return;
      }
      backupApplianceList.value = [];
      applianceList.value.forEach(item => {
        backupApplianceList.value.push(
          new ApplianceData(item.id, item.check, item.product)
        );
      });
      await _sleep(500);
      isShowApplianceDialog.value = true;
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.SEARCH_APPLIANCE_DIALOG, null, new Array<string>());
      NativeClient.sendViewedLog(beaconLogInfo);
    };

    const closeApplianceDialog = () => {
      backupApplianceList.value.forEach(backupItem => {
        applianceList.value.forEach(item => {
          if (backupItem.id == item.id) {
            item.check = backupItem.check;
          }
        });
      });
      backupApplianceList.value = [];
      selectApplianceText.value = getApplianceText();
      isShowApplianceDialog.value = false;
    };

    const positiveApplianceDialog = () => {
      backupApplianceList.value = [];
      selectApplianceText.value = getApplianceText();
      saveSearchApplianceList();
      isShowApplianceDialog.value = false;
    };

    const selectCheck = (id: number, checked: boolean) => {
      NativeClient.sendDebugLog(
        "SearchDetailPage selectApplianceCheck id=" + id + " checked=" + checked
      );
      for (let i = 0; i < applianceList.value.length; i++) {
        const item = applianceList.value[i];
        if (item.id == id) {
          item.check = checked;
        }
      }
    };

    const isShowApplianceEdit = () => {
      return applianceList.value.length >= 1;
    };

    const handleEnter = () => {
      if (textInput.value != undefined) {
        textInput.value.blur();
      }
    };

    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      closeDialog,
      getRecipes,
      retryGetRecipes,
      keywordComputed,
      setTag,
      SEARCH_RECIPE_TYPE,
      setKeyword,
      removeSearchHistory,
      historyKeywordList,
      onClickClear,
      onClickSearch,
      tagGroupsInfo,
      isShowApplianceDialog,
      showApplianceDialog,
      closeApplianceDialog,
      getApplianceText,
      applianceList,
      selectCheck,
      selectApplianceText,
      getSearchAppliance,
      positiveApplianceDialog,
      isShowApplianceEdit,
      handleEnter,
      textInput
    };
  }
});
